import instance from "../axios";
import { errorHandler } from "./index";

export const mapMakeOption = (item) => {
  const label =
    item?.makeName || item?.name || item?.make || item?.label || "";
  const id = item?.id ?? label;
  return { id, label, value: label, key: id };
};

export const createMakesPaginationRef = () => ({
  page: 1,
  hasNext: false,
  search: "",
  loading: false,
});

export const fetchMakesPage = (
  { makesPaginationRef, setState, getAllMakes, dispatch },
  page = 1,
  make = "",
  reset = false,
) => {
  if (makesPaginationRef.loading) {
    return Promise.resolve(getAllMakes());
  }

  makesPaginationRef.loading = true;
  setState({ makesLoading: true });

  return instance({
    method: "GET",
    url: `/api/makes/get?page=${page}&limit=20&make=${encodeURIComponent(make || "")}`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      const options = (response?.data || []).map(mapMakeOption);
      const nextPage = response?.page ?? page;

      makesPaginationRef.page = nextPage;
      makesPaginationRef.hasNext = Boolean(response?.hasNext);
      makesPaginationRef.search = make;
      makesPaginationRef.loading = false;

      setState((prev) => {
        const merged = reset ? options : [...prev.allMakes, ...options];
        const allMakes = merged.filter(
          (item, index, arr) =>
            arr.findIndex((x) => x.id === item.id) === index,
        );
        return { allMakes, makesLoading: false };
      });

      return options;
    })
    .catch((error) => {
      makesPaginationRef.loading = false;
      setState({ makesLoading: false });
      if (dispatch) {
        errorHandler(error, dispatch);
      }
      return [];
    });
};

export const createMakesHandlers = (component) => {
  if (!component.makesPaginationRef) {
    component.makesPaginationRef = createMakesPaginationRef();
  }
  if (component.makeSearchTimeout === undefined) {
    component.makeSearchTimeout = null;
  }

  return {
    fetchMake: () =>
      fetchMakesPage(
        {
          makesPaginationRef: component.makesPaginationRef,
          setState: component.setState.bind(component),
          getAllMakes: () => component.state.allMakes,
          dispatch: component.props?.dispatch,
        },
        1,
        "",
        true,
      ),
    onMakeInputChange: (inputValue, { action }) => {
      if (action !== "input-change") return;

      if (component.makeSearchTimeout) {
        clearTimeout(component.makeSearchTimeout);
      }

      component.makeSearchTimeout = setTimeout(() => {
        fetchMakesPage(
          {
            makesPaginationRef: component.makesPaginationRef,
            setState: component.setState.bind(component),
            getAllMakes: () => component.state.allMakes,
            dispatch: component.props?.dispatch,
          },
          1,
          inputValue,
          true,
        );
      }, 300);
    },
    loadMoreMakes: () => {
      const { hasNext, loading, page, search } = component.makesPaginationRef;
      if (!hasNext || loading) return;

      fetchMakesPage(
        {
          makesPaginationRef: component.makesPaginationRef,
          setState: component.setState.bind(component),
          getAllMakes: () => component.state.allMakes,
          dispatch: component.props?.dispatch,
        },
        page + 1,
        search,
        false,
      );
    },
    clearMakeSearchTimeout: () => {
      if (component.makeSearchTimeout) {
        clearTimeout(component.makeSearchTimeout);
        component.makeSearchTimeout = null;
      }
    },
  };
};
